export const isIndexValid = (index, offices, locationId) => {
  if (!offices || !offices.length) return false;
  if (index < 0 || index >= offices.length) return false;
  if ((locationId !== null) && (offices[index].location_id !== Number(locationId))) return false;
  return true;
}